export default __webpack_public_path__ + "static/media/Sentiment_02_Result.641e6fef.png";